import styled from "styled-components";
import drop from "../../assets/water-drop.png";
const fontSize = localStorage.getItem("fontSize");

export const HelpHeader = styled.header`
  background: url(${drop});
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const HelpBadge = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 80%;
  position: absolute;
  right: 10%;
  top: 10rem;
`;

export const HelpBageTop = styled.div`
  padding: 1rem;
  height: 50%;
  background: #62aa51;
  color: #fff;
  text-align: center;
`;
export const HelpBageBottom = styled.div`
  padding: 1rem;
  height: 50%;
  background: #fff;
  color: #101e8e;
  font-size: calc(${fontSize} - 0.3rem);
  text-align: center;
`;

export const HelpMainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

export const HelpContainer = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: auto;
  margin-top: 10rem;
`;

export const HelpCards = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

export const HelpCard = styled.div`
display: flex;
flex-direction: column;
justify-content: space-around;
width: 45%;
gap: 0;
img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin: 0;
}
p {
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: .5rem;
  text-align: center;
  height: 100%;
  background: #101e8e;
  color: #fff;
`;

export const HelpSection = styled.section`
  width: 100%;
  img {
    width: 100%;
    height: 50%;
    object-fit: fill;
    margin: 0;
  }
`;
export const HelpSectionCards = styled.div`
  display: flex;
  width: 80%;
  justify-content: space-between;
  gap: 1rem;
  margin: auto;
`;

export const HelpSectionCard = styled.div`
  width: 45%;
  margin-top: -7rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #62aa51;
  padding: 0.2rem;
  span {
    width: 90%;
    color: white;
  }
  h3 {
    color: #fff;
  }
`;
